import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';
import { getHeader } from '@/utils/storage';

const baseUrl = envConfig.storageServiceUrl + '/cloud-storage/admin/slowExecute/';

function baseApi() {

    function queryList(data, appId) {
        return Post(baseUrl + `queryList`, data, getHeader(appId));
    }

    return { queryList };
}

export const slowlyExecuteApi = baseApi();
